import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { EIDs } from '../common/enums';
import { getText, getPath } from '../common/utils/helpers';
import { fetchData } from '../common/app/actions';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      treeContainerStyle: {
        position: 'relative',
        // width: '80%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
      },
      titleStyle: {
        fontWeight: FONT_WEIGHT.bold,
        fontSize: '16px',
        fontFamily: FONTS.alegreya,
        color: COLORS.textGray,
        marginBottom: '10px',
      },
      treeWrapperStyle: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        justifyContent: 'center',
      },
      themeStyle: {
        fontWeight: FONT_WEIGHT.bold,
        fontSize: '20px',
        fontFamily: FONTS.garamond,
        color: COLORS.appBlue,
        padding: '6px',
        textAlign: 'center',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      capitalStyle: {
        textTransform: 'uppercase',
      },
      [`@media (max-width: 840px)`]: {
        treeContainerStyle: {
          alignItems: 'flex-start',
          marginBottom: '30px',
        },
        treeWrapperStyle: {
          flexDirection: 'row',
          justifyContent: 'flex-start',
        },
        themeStyle: {
          textAlign: 'left',
          fontSize: '18px',
        },
      },
      [`@media (max-width: 410px)`]: {
        themeStyle: {
          fontSize: '16px',
        },
      },
    })
);

const Tree = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [sizedThemesData, setSizedThemesData] = useState(null);

  const themesData = useSelector((state: any) => state.app.themesData);

  useEffect(() => {
    dispatch(fetchData(C.THEMES_DATA, { themes: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /*
  useEffect(() => {
    if (themesData && !sizedThemesData) {
      const adjustedThemesData = themesData.map((item) => {
        const bigTitle: boolean = Math.random() < 0.5;

        return {
          ...item,
          bigTitle,
        };
      });

      setSizedThemesData(adjustedThemesData);
    }
  }, [themesData]); // eslint-disable-line react-hooks/exhaustive-deps
  */

  if (!themesData) {
    return null;
  }

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    const uid = event.currentTarget.getAttribute('data-name');
    navigate({ pathname: `${ROUTES.THEME}/${uid}` });
  };

  const getThemes = (item, index) => {
    const isBigTitle = item.content.uppercase === 'true';

    // const randomNr = Math.floor(Math.random() * 50);

    // const opacity = (100 - randomNr) / 100;

    return (
      <div
        key={index}
        className={clsx(classes.themeStyle, isBigTitle && classes.capitalStyle)}
        data-name={item.content.uid}
        onClick={onClick}
      >
        {item.content.title_lv}
      </div>
    );
  };

  return (
    <div className={classes.treeContainerStyle}>
      <div className={classes.titleStyle}>{'VISAS TĒMAS:'}</div>
      <div className={classes.treeWrapperStyle}>
        {themesData.map(getThemes)}
      </div>
    </div>
  );
};

export default Tree;
